import { render, staticRenderFns } from "./ProductDetailsGroup.vue?vue&type=template&id=50625e51&"
import script from "./ProductDetailsGroup.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports